import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { Box, Grid, InputAdornment, Typography } from "@mui/material"
import VoucherApi from "api/voucher/voucher.api"
import TableRowExport from "component/Pdf/TableRowExport"
import TableCustom from "component/Table/TableCustom"
import TableRowCommon from "component/Table/TableRowCommon"
import TextInput from "new-components/inputs/text-input"
import { useEffect, useRef, useState } from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import AddCircleIcon from '@mui/icons-material/AddCircle'
import Loading from "component/Loading"
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from "new-components/buttons/switch-button"
import SelectInput from 'new-components/inputs/select-input'
import AlertModal from "new-components/modal/alert-modal"
import PageModal from "new-components/modal/page-modal"
import SnackbarComponent from "new-components/snackbar/snackbar-component"
import { useTranslation } from "react-i18next"
import { dateTimeToView } from 'utils/date.utils'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'
import { exportVoucherTypeToExcel } from './exportVoucherTypeToExcel'

const permissions = {
    isCreate: isCreate(),
    isDelete: isDelete(),
    isUpdate: isUpdate(),
    isView: isView()
}

const VoucherType = () => {
    ////-------------------
    ////    I18N
    ////-------------------
    const { t } = useTranslation()
    ////-------------------
    ////    STATE
    ////-------------------
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('approvalId')
    const [sortType, setSortType] = useState('ASC')
    const [search, setSearch] = useState('')
    const [statusSelect, setStatusSelect] = useState<string>('ALL')
    const [loading, setLoading] = useState<boolean>(true)
    const [dataVoucher, setDataVoucher] = useState<any>([])
    const [dataVoucherExport, setDataVoucherExport] = useState<any>([])
    const [isOpen, setIsOpen] = useState(false)
    const [status, setStatus] = useState('')
    const [id, setId] = useState<number>(0)
    const [name, setName] = useState('')
    const [nameEn, setNameEn] = useState('')
    const [alertModal, setAlertModal] = useState(false)
    const [isOpenSnack, setIsOpenSnack] = useState(false)
    const [typeSnack, setTypeSnack] = useState<any>("success")
    const [labelSnack, setLabelSnack] = useState('')
    const [statusSwitch, setStatusSwitch] = useState(true)
    const [errorMessage, setErrorMessage] = useState<any>({})
    const [disabledSubmit, setDisabledSubmit] = useState(false)
    const componentRef = useRef<HTMLDivElement>(null)

    const preparation = async (searchData?: string, checkExport?: boolean) => {
        setLoading(true)
        const condition = {
            page: checkExport ? 1 : page,
            pageLimit: checkExport ? 1000000 : pageLimit,
            SEARCH: searchData === '' ? '' : search,
            sortBy: sortBy,
            sortType: sortType,
            STATUS: statusSelect === 'ALL' ? '' : statusSelect,
            EXPORT: checkExport ? '1' : '0'
        }
        await VoucherApi.findAllType(condition).then((resp) => {
            if (resp.status === 200) {
                if (checkExport) {
                    setDataVoucherExport(resp.data)
                } else {
                    setRowCount(resp?.headers['x-total'] || 0)
                    setDataVoucher(resp.data)
                }
            }
        })

        setLoading(false)
    }

    ////-------------------
    ////    EFFECT
    ////-------------------
    useEffect(() => {
        preparation()
        return () => {
            setId(0)
            setName('')
            setNameEn('')
            setErrorMessage({})
        }
    }, [page, pageLimit, sortBy, sortType])

    useEffect(() => {
        preparation('', true)
    }, [])

    ////-------------------
    ////    HANDLE
    ////-------------------
    const headCells = [
        { id: 'no', disablePadding: false, label: t('TABLE.NO'), width: '50px', align: 'center', },
        { id: 'voucherTypeName', disablePadding: false, label: t('VOUCHER_TYPES.TABLE.VOUCHER_TYPENAME'), align: 'left', },
        { id: 'voucherTypeNameEn', disablePadding: false, label: t('VOUCHER_TYPES.TABLE.VOUCHER_TYPENAMEEN'), align: 'left', },
        { id: 'status', disablePadding: false, label: t('VOUCHER_TYPES.TABLE.VOUCHER_STATUS'), align: 'center', width: '150px' },
        { id: 'updatedBy', disablePadding: false, label: t('VOUCHER_TYPES.TABLE.UPDATED_BY'), align: 'center', width: '180px' },
        { id: 'action', disablePadding: false, label: 'Action', width: '80px' }
    ]

    const renderData = (objData: any, index: number, isExport?: boolean) => {
        if (isExport) {
            index = index + 1
        } else {
            index = page * pageLimit - pageLimit + index + 1
        }

        const { voucherTypeId, voucherTypeName, voucherTypeNameEn, updatedBy, updatedAt, createdAt, status } = objData

        const objRenderData = {
            key: voucherTypeId,
            id: voucherTypeId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: index },
                { option: 'TEXT', align: 'left', label: voucherTypeName || '' },
                { option: 'TEXT', align: 'left', label: voucherTypeNameEn || '' },
                { option: 'STATUS', align: 'center', label: status },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy || '-', updatedAt: updatedAt ?? '10/12/2564 08.59' } },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    values: [
                        { option: 'STATUS_ACTIVE', label: t('VOUCHER_TYPES.ACTION.STATUS_ACTIVE'), disabled: status === 'ACTIVE' },
                        { option: 'STATUS_INACTIVE', label: t('VOUCHER_TYPES.ACTION.STATUS_INACTIVE'), disabled: status === 'INACTIVE' },
                        { option: 'DIVIDER', label: '', disabled: false },
                        { option: 'EDIT', label: t('VOUCHER_TYPES.ACTION.EDIT'), disabled: permissions.isUpdate.disabled },
                        { option: 'DELETE', label: t('VOUCHER_TYPES.ACTION.DELETE'), disabled: permissions.isDelete.disabled }
                    ]
                },
            ]
        }

        if (isExport) {
            return <TableRowExport {...objRenderData} />
        }

        return (
            <TableRowCommon
                {...objRenderData}
                onedit={() => onEdit(objRenderData.obj)}
                ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETED', objRenderData.obj)}
                onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
                oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
            />
        )
    }

    const onEdit = (data: any) => {
        setIsOpen(true)
        setId(data.voucherTypeId)
        setStatusSwitch(data.status === 'INACTIVE' ? false : true)
        setName(data.voucherTypeName)
        setNameEn(data.voucherTypeNameEn)
    }


    const handleSubmitModal = (id: number, status: string, obj?: any) => {
        if (status === 'DELETED') {
            setStatus("DELETED")
            setId(obj.voucherTypeId)
            setName(obj.voucherTypeName)
            setNameEn(obj.voucherTypeNameEn)
            setAlertModal(true)
        } else {
            setAlertModal(true)
            setId(id)
            setStatus(status)
            setName(obj.voucherTypeName)
            setNameEn(obj.voucherTypeNameEn)
        }
    }

    const onActive = () => {
        if (id) {
            VoucherApi.chagneStatusVoucherType(id, { voucherTypeName: name, voucherTypeNameEn: nameEn, status: status }).then((resp) => {
                if (resp.status === 200) {
                    setAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('VOUCHER_TYPES.MESSAGE.SUCCESS'))
                    preparation(search, true)
                    preparation()
                } else {
                    setAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('VOUCHER_TYPES.MESSAGE.ERROR'))
                }
            }).catch((error) => {
                setAlertModal(false)
                setLoading(false)
                setIsOpenSnack(true)
                setTypeSnack("error")
                if (error?.response?.data?.message === 'THIS_VOUCHER_TYPE_IS_BEING_USED' || error?.response?.data?.message === 'THIS_VOUCHER_IS_BEING_USED') {
                    setLabelSnack(t('VOUCHER_TYPES.MESSAGE.DUPICATE'))
                } else {
                    setLabelSnack(t('VOUCHER_TYPES.MESSAGE.ERROR'))
                }
            })
        }
    }

    const onDelete = () => {
        if (id) {
            VoucherApi.chagneStatusVoucherType(id, { voucherTypeName: name, voucherTypeNameEn: nameEn, status: status }).then((resp) => {
                if (resp.status === 200) {
                    setAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('VOUCHER_TYPES.MESSAGE.DELETE_SUCCESS'))
                    preparation(search, true)
                    preparation()
                } else {
                    setAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('VOUCHER_TYPES.MESSAGE.ERROR'))
                }
            }).catch((error) => {
                setAlertModal(false)
                setLoading(false)
                setIsOpenSnack(true)
                setTypeSnack("error")
                if (error?.response?.data?.message === 'THIS_VOUCHER_TYPE_IS_BEING_USED' || error?.response?.data?.message === 'THIS_VOUCHER_IS_BEING_USED') {
                    setLabelSnack(t('VOUCHER_TYPES.MESSAGE.DUPICATE'))
                } else {
                    setLabelSnack(t('VOUCHER_TYPES.MESSAGE.ERROR'))
                }
            })
        }
    }

    const onSubmit = async () => {
        setLoading(true)
        setDisabledSubmit(true)
        if (!name) {
            setDisabledSubmit(false)
            setErrorMessage({
                NAME: !name && t('VOUCHER_TYPES.MODAL.ERROR_VOUCHER_TITLE'),
            })
            setLoading(false)
            return
        }

        if (name?.length > 255 || nameEn?.length > 255) {
            setDisabledSubmit(false)
            setIsOpenSnack(true)
            setTypeSnack("error")
            setLabelSnack(t('VOUCHER_TYPES.MODAL.ERROR_TITLE_LENGTH'))
            setLoading(false)
            return
        }

        if (id === 0) {
            VoucherApi.createVoucherType({
                voucherTypeName: name,
                voucherTypeNameEn: nameEn
            }).then(() => {
                setDisabledSubmit(false)
                setIsOpen(false)
                setIsOpenSnack(true)
                setTypeSnack('success')
                setLabelSnack(t('VOUCHER_TYPES.MESSAGE.ADD_SUCCESS'))
                preparation(search, true)
                preparation()
            }).catch((error) => {
                setLoading(false)
                setDisabledSubmit(false)
                if (error?.response?.data?.message === 'THIS_VOUCHER_TYPE_IS_BEING_USED' || error?.response?.data?.message === 'THIS_VOUCHER_IS_BEING_USED') {
                    setTypeSnack('error')
                    setIsOpenSnack(true)
                    return setLabelSnack(t('VOUCHER_TYPES.MESSAGE.DUPICATE'))
                } else if (error.response?.data?.message === 'IS_DUPLICATE_TYPE_NAME') {
                    return setErrorMessage({ NAME: t('VOUCHER_TYPES.MODAL.DUPICATE_NAME') })
                } else if (error.response?.data?.message === 'IS_DUPLICATE_TYPE_NAME_EN') {
                    return setErrorMessage({ NAME_EN: t('VOUCHER_TYPES.MODAL.DUPICATE_NAME_EN') })
                } else {
                    setTypeSnack('error')
                    setIsOpenSnack(true)
                    return setLabelSnack(t('VOUCHER_TYPES.MESSAGE.ERROR'))
                }
            })
        } else {
            VoucherApi.updateVoucherType(id, {
                status: statusSwitch ? 'ACTIVE' : 'INACTIVE',
                voucherTypeName: name,
                voucherTypeNameEn: nameEn
            }).then(() => {
                setDisabledSubmit(false)
                setIsOpen(false)
                setIsOpenSnack(true)
                setTypeSnack('success')
                setLabelSnack(t('VOUCHER_TYPES.MESSAGE.EDIT_SUCCESS'))
                preparation(search, true)
                preparation()
            }).catch((error) => {
                setLoading(false)
                setDisabledSubmit(false)
                if (error?.response?.data?.message === 'THIS_VOUCHER_TYPE_IS_BEING_USED' || error?.response?.data?.message === 'THIS_VOUCHER_IS_BEING_USED') {
                    setIsOpenSnack(true)
                    setTypeSnack('error')
                    setLabelSnack(t('VOUCHER_TYPES.MESSAGE.DUPICATE'))
                } else if (error.response?.data?.message === 'IS_DUPLICATE_TYPE_NAME') {
                    setErrorMessage({ NAME: t('VOUCHER_TYPES.MODAL.DUPICATE_NAME') })
                } else if (error.response?.data?.message === 'IS_DUPLICATE_TYPE_NAME_EN') {
                    setErrorMessage({ NAME_EN: t('VOUCHER_TYPES.MODAL.DUPICATE_NAME_EN') })
                } else {
                    setIsOpenSnack(true)
                    setTypeSnack('error')
                    setLabelSnack(t('VOUCHER_TYPES.MESSAGE.ERROR'))
                }
            })
        }
        setErrorMessage({})
    }

    return (
        <Box>
            <Loading show={loading} />
            <AlertModal
                isOpen={alertModal}
                title={status === "DELETED" ? t('VOUCHER_TYPES.MESSAGE.DELETE_TITLE') : t('VOUCHER_TYPES.MESSAGE.STATUS_TITLE')}
                message={status === "DELETED" ? t('VOUCHER_TYPES.MESSAGE.DELETE_MESSAGE', { name: name, nameEn: nameEn }) : t('VOUCHER_TYPES.MESSAGE.STATUS_MESSAGE', { name: name, status: t(`VOUCHER_TYPES.STATUS.${status}`) })}
                type={status === "DELETED" ? 'error' : 'warning'}
                onSubmit={{ onClick: status === 'DELETED' ? onDelete : onActive, title: t('VOUCHER_TYPES.MESSAGE.BUTTON_SAVE_DELETE') }}
                onCancel={{ onClick: () => setAlertModal(false), title: t('VOUCHER_TYPES.MESSAGE.BUTTON_CANCEL') }}
                handleClose={() => setAlertModal(false)}
            />
            <SnackbarComponent
                onOpen={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                label={labelSnack}
                type={typeSnack}
                transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
                autoHideTime={3000}
            />
            <PageModal
                isOpen={isOpen}
                title={`${id !== 0 ? t('VOUCHER_TYPES.MODAL.UPDATE_VOUCHER_TITLE') : t('VOUCHER_TYPES.MODAL.CREATE_VOUCHER_TITLE')}`}
                size="XS"
                onSubmit={{ onClick: onSubmit, title: t('VOUCHER_TYPES.MODAL.BUTTON_SAVE'), disabled: disabledSubmit }}
                onCancel={{
                    onClick: () => {
                        setErrorMessage({})
                        setIsOpen(false)
                    }, title: t('VOUCHER_TYPES.MODAL.BUTTON_CANCEL')
                }}
                handleClose={() => {
                    setErrorMessage({})
                    setIsOpen(false)
                }}
            >
                <Box marginTop="16px">
                    {id !== 0 && <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px">
                        <Typography fontSize="16px" fontWeight={400}>{t('VOUCHER_TYPES.MODAL.STATUS')}</Typography>
                        <SwitchButton checked={statusSwitch} onChange={(e) => setStatusSwitch(e.target.checked)} />
                    </Box>}
                    <Box display="flex" flexDirection="column" gap="16px">
                        <TextInput
                            required
                            value={name}
                            inputProps={{ value: name }}
                            label={t('VOUCHER_TYPES.MODAL.VOUCHER_TYPE')}
                            onChange={(e) => {
                                setErrorMessage({})
                                setName(e.target.value)
                            }}
                            fullWidth
                            helperText={errorMessage.NAME}
                        />
                        <TextInput
                            label={t('VOUCHER_TYPES.MODAL.VOUCHER_TYPEEN')}
                            value={nameEn}
                            inputProps={{ value: nameEn }}
                            onChange={(e) => {
                                setErrorMessage({})
                                setNameEn(e.target.value)
                            }}
                            fullWidth
                            helperText={errorMessage.NAME_EN}
                        />
                    </Box>
                </Box>
            </PageModal>
            <Box width="100%" height="80px" boxShadow="0px 3px 6px 0px #0000001F" border="1px solid #E5E5E5" paddingLeft="24px" display="flex" alignItems="center" fontSize="20px" fontWeight={500}  >
                {t('VOUCHER_TYPES.TITLE')}
            </Box>
            <Box paddingX="24px" paddingTop="16px">
                <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <TextInput
                            onChange={(event) => {
                                setSearch(event.target.value);
                            }}
                            label={t('VOUCHER_TYPES.SEARCH')}
                            value={search}
                            size='large'
                            fullWidth={true}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    setPage(1)
                                    preparation(search, true)
                                    preparation()
                                }
                            }}
                            inputProps={{
                                value: search,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => {
                                                    setSearch('')
                                                }}
                                                style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <SelectInput
                            value={statusSelect}
                            onChange={(event: any) => {
                                setStatusSelect(event.target.value)
                            }}
                            defaultValue={statusSelect}
                            label="สถานะ"
                            options={[
                                { name: t('VOUCHER_TYPES.STATUS.ALL'), value: "ALL" },
                                { name: t('VOUCHER_TYPES.STATUS.ACTIVE'), value: "ACTIVE" },
                                { name: t('VOUCHER_TYPES.STATUS.INACTIVE'), value: "INACTIVE" }
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={8}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <MainButton
                                title={t('VOUCHER_TYPES.BUTTON.SEARCH')}
                                onClick={() => {
                                    setPage(1)
                                    preparation(search, true)
                                    preparation()
                                }}
                                type="primary"
                                variant="contained"
                                style={{ height: '40px', width: '100px' }}
                            />
                            <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                                <DropdownButton title={'พิมพ์เอกสาร'} onChange={(e) => {
                                    if (e === 'Excel') {
                                        const report: any = {
                                            title: 'จัดการประเภท Gift Voucher',
                                            statusFilter: statusSelect === 'ALL'
                                                ? 'ทั้งหมด'
                                                : statusSelect === 'ACTIVE'
                                                    ? 'เปิดใช้งาน'
                                                    : 'ปิดใช้งาน',
                                            rows: dataVoucherExport.map((item: any) => ({
                                                voucherTypeName: item.voucherTypeName || '-',
                                                voucherTypeNameEn: item.voucherTypeNameEn || '-',
                                                status: t(`STATUS.${item?.status}`),
                                                updatedBy: item.updatedBy || '-',
                                                updatedAt: dateTimeToView(item.updatedAt)
                                            })),
                                            t
                                        }
                                        exportVoucherTypeToExcel(report)

                                    } else if (e === 'PDF') {
                                        const style = document.createElement("style");
                                        style.innerHTML = `
                            @media print {
                                @page {size: portrait }
                                                                                        }
                            `;
                                        document.head.appendChild(style);
                                        window.print();
                                        document.head.removeChild(style);

                                    }
                                }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
                                <MainButton
                                    onClick={() => {
                                        setName('')
                                        setNameEn('')
                                        setId(0)
                                        setIsOpen(true)
                                    }}
                                    title={t('VOUCHER_TYPES.BUTTON.CREATE_VOUCHER')}
                                    type="primary"
                                    variant="contained"
                                    startIcon={<AddCircleIcon />}
                                    style={{ height: '40px' }}
                                    disabled={permissions.isCreate.disabled}
                                />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Box marginTop="24px">
                    <TableCustom
                        page={page}
                        pageLimit={pageLimit}
                        sortType={sortType}
                        sortBy={sortBy}
                        onSort={(sortByVal: string, sortTypeVal: string) => {
                            setSortType(sortTypeVal)
                            setSortBy(sortByVal)
                        }}
                        setPageLimit={(e) => setPageLimit(e)}
                        setPage={(e) => setPage(e)}
                        rowCount={rowCount}
                        headCells={headCells}
                        rowsData={dataVoucher.map((item: any, index: number) => {
                            return renderData(item, index)
                        })}
                    />
                </Box>
            </Box>
            <Box
                id="print-table-container"
                ref={componentRef}
            >
                <Typography fontSize="14px" fontWeight={400}>{t('VOUCHER_TYPES.TITLE')}</Typography>
                <Box display='flex' flexDirection="row" alignItems="center" gap="16px">
                    <Typography fontSize="10px" fontWeight={400}>{t('STATUS.LABEL')}: {statusSelect === 'ALL' ? t('STATUS.ALL') : statusSelect === 'ACTIVE' ? t('STATUS.ACTIVE') : t('STATUS.INACTIVE')}</Typography>
                </Box>
                <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
                    <thead>
                        <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                            <th style={{ borderBottom: '1px solid black' }}>{t('#')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('VOUCHER_TYPES.TABLE.VOUCHER_TYPENAME')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('VOUCHER_TYPES.TABLE.VOUCHER_TYPENAMEEN')}</th>
                            <th style={{ borderBottom: '1px solid black' }}>{t('VOUCHER_TYPES.TABLE.VOUCHER_STATUS')}</th>
                            <th style={{ borderBottom: '1px solid black' }}>{t('VOUCHER_TYPES.TABLE.UPDATED_BY')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataVoucherExport?.length === 0 &&
                            <tr>
                                <td colSpan={5} style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100%' }}>{t('NOT_FOUND')}</td>
                            </tr>
                        }
                        {dataVoucherExport.map((data: any, index: number) => (
                            <tr key={index}>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{index + 1}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.voucherTypeName || '-'}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.voucherTypeNameEn || '-'}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100px' }}>{t(`STATUS.${data?.status}`) || '-'}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <span>{data?.updatedBy || '-'}</span>
                                    <span>{dateTimeToView(data?.updatedAt) || '-'}</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Box>
        </Box>
    )
}
export default VoucherType